// const pkg = require('json-loader!../../package.json')
module.exports = {
  version: '0.12.0',
  env: __DEPLOY_ENV__,
}
